export const STATUS_NOT_FOUND = 404
